import { Flex } from "@mantine/core";
import { useCallback } from "react";
import {
  type UseFieldArrayReturn,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { type IBiofoulingSetupForm } from "src/pages/Settings/YachtSetup/BiofoulingSetUp/BiofoulingSetUp.types";

import BiofoulingItem from "./BiofoulingItem";

type Props = Omit<UseFieldArrayReturn<IBiofoulingSetupForm>, "append">;

const BiofoulingSections = ({ fields, remove }: Props) => {
  const { control } = useFormContext();
  const section = useWatch({ control, name: "section" });

  const getItems = useCallback(() => {
    const items: any[] = [];
    fields.forEach((field, index) => {
      if (field.section === section) {
        items.push({ ...field, index });
      }
    });
    return items;
  }, [fields, section]);

  return (
    <Flex
      direction="column"
      align="center"
      maw="800px"
      w="100%"
      h="100%"
      style={{ overflowY: "auto", alignSelf: "stretch", minHeight: 0 }}>
      {getItems().map(field => (
        <BiofoulingItem
          key={field.id}
          id={`areas.${field.index}`}
          remove={() => remove(field.index)}
          disabled={field.disabled}
        />
      ))}
    </Flex>
  );
};

export default BiofoulingSections;
